import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../../utils/axios";
const initialState = {
  data: [],
  loading: false,
  message: "",
  completed: false,
  hasError: false,
};

export const fetchInstagramRaw = createAsyncThunk(
  "instagramRawData/fetchInstagramRaw",

  async ({ lte, gte, interval }) => {
    const response = await axiosInstance.request({
      url: `instagram/raw`,
      method: `GET`,
      params: {
        lte,
        gte,
        interval,
      },
    });
    return response;
  }
);

const instagramRawDataSlice = createSlice({
  name: "instagramRawData",
  initialState,
  reducers: {
    clearData: () => {
      return initialState;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchInstagramRaw.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInstagramRaw.fulfilled, (state, action) => {
        state.loading = false;
        state.completed = true;
        state.data = action.payload.data;
      })
      .addCase(fetchInstagramRaw.rejected, (state, action) => {
        state.loading = false;
        state.completed = true;
        state.hasError = true;
        state.message = action.error.message;
      });
  },
});

const InstagramRawDataReducer = instagramRawDataSlice.reducer;

export default InstagramRawDataReducer;

export const instagramRawDataAction = instagramRawDataSlice.actions;
